/**
 * axios封装
 * 请求拦截、相应拦截、错误统一处理
 */
import axios from 'axios'
import store from './vuex/store'
import Toast from './muse-ui-plugin/muse-ui-toast'

// 环境的切换

// 请求超时时间
axios.defaults.timeout = 300000;

// post请求头
axios.defaults.headers.post['Content-Type'] = 'application/json;charset=UTF-8';

axios.defaults.withCredentials = true
// 请求拦截器
axios.interceptors.request.use(
    config => {
        config.baseURL = process.env.BASE_API;

        // 每次发送请求之前判断是否存在token，如果存在，则统一在http请求的header都加上token，不用每次请求都手动添加了
        // 即使本地存在token，也有可能token是过期的，所以在响应拦截器中要对返回状态进行判断
        const token = store.getters.token;
        if (token) {
            config.headers['Authorization'] = 'Bearer ' + token;
        } else {
            config.headers['Authorization'] = '';
        }
        return config;
    },
    error => {
        console.log("interceptors.request error:" + error);
        return Promise.error(error);
    })

// 响应拦截器
axios.interceptors.response.use(
    response => {
        if (response.status === 200) {
            return Promise.resolve(response);
        } else {
            return Promise.reject(response);
        }
    },
    // 服务器状态码不是200的情况
    error => {
        if (error.response.status) {
            console.log("response error code:" + error.response.status);
            switch (error.response.status) {
                // 401: 未登录
                // 未登录则跳转登录页面，并携带当前页面的路径
                // 在登录成功后返回当前页面，这一步需要在登录页操作。
                case 401:
                    Toast.error({
                        message: '用户未登陆',
                        time: 1600,
                        close: true
                    });
                    setTimeout(() => {
                        location.href = "/";
                    }, 1200);
                    break;
                // 403 token过期
                // 登录过期对用户进行提示
                // 清除本地token和清空vuex中token对象
                // 跳转登录页面
                case 403:
                    Toast.error({
                        message: '登录过期，请重新登录',
                        time: 1600,
                        close: true
                    });
                    // 清除token
                    localStorage.removeItem('token');
                    // 跳转登录页面，并将要浏览的页面fullPath传过去，登录成功后跳转需要访问的页面
                    setTimeout(() => {
                        location.href = "/";
                    }, 1000);
                    break;
                // 404请求不存在
                case 404:
                    Toast.error({
                        message: '网络请求不存在',
                        time: 15000,
                        close: true
                    });

                break;
                // 其他错误，直接抛出错误提示
                default:
                    Toast.error({
                        message: error.response.data.message,
                        time: 1500,
                        close: true
                    });
            }
            return Promise.reject(error.response);
        }
    }
);
export function getUrl() {
    return axios.defaults.baseURL;
}
/**
 * get方法，对应get请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */
export function get(url, params){
    if (params == null) {
        params = {};
    }
    return new Promise((resolve, reject) =>{
        axios.get(url, {
            params: params
        })
        .then(res => {
            resolve(res.data);
        })
        .catch(err => {
            reject(err.data)
        })
    });
}
/**
 * post方法，对应post请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */
export function post(url, params) {
    return new Promise((resolve, reject) => {
        axios.post(url, params)
        .then(res => {
            resolve(res.data);
        })
        .catch(err => {
            console.log(err);
            reject(err.data)
        })
    });
}

/**
 * delete方法，对应delete请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */
 export function del(url, params) {
    return new Promise((resolve, reject) => {
        axios.delete(url, params)
        .then(res => {
            resolve(res.data);
        })
        .catch(err => {
            reject(err.data)
        })
    });
}

/**
 * put方法
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */
 export function put(url, params) {
    return new Promise((resolve, reject) => {
        axios.put(url, params)
        .then(res => {
            resolve(res.data);
        })
        .catch(err => {
            reject(err.data)
        })
    });
}


/**
 * postForm
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */
 export function postForm(url, params) {
    var bodyFormData = new FormData();
    return new Promise((resolve, reject) => {
        axios.post({
            method: 'post',
            url: url,
            data: bodyFormData
        })
        .then(res => {
            resolve(res.data);
        })
        .catch(err => {
            reject(err.data)
        })
    });
}


// WEBPACK FOOTER //
// ./src/axios.js